'use strict';

import { addEvent } from './addEvent/addEvent';
import { asideMenuInit } from './aside/aside';
// import { fslightboxInit } from './fslightbox/fslightbox';
import { tableWrapperInit } from './tableWrapper/tableWrapper';
import { pageBaner } from './pageBaner/pageBaner';
import { wyborPlatnosci, czy_firma } from './koszyk/koszyk';

document.addEventListener('DOMContentLoaded', () => {
  asideMenuInit();
  // fslightboxInit();
  tableWrapperInit();
  pageBanerInit();
  wyborPlatnosci();
  czy_firma();
});

addEvent(window, 'load', () => {});

addEvent(window, 'resize', () => {});

addEvent(window, 'scroll', () => {});

function pageBanerInit() {
  const elements = document.querySelectorAll('.page-baner-container');
  elements.forEach(element => {
    new pageBaner(element);
  });
}
